module.exports = require("slate-react");